<script setup>
  import {ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import PatientsPatientAttributesData from "@pages/Patients/Components/PatientAttributesData.vue";

  defineOptions({
    name: "ComponentPatientAttributesDialog",
  });

  defineProps({
    patient: {
      type: Object,
      required: true,
    },
  });

  const refPatientAttributesDialog = ref(null);

  const open = () => {
    refPatientAttributesDialog.value.open();
  };

  // TODO Rename dafuq
  const closeDialog = () => {
    refPatientAttributesDialog.value.close();
  };

  defineExpose({
    open,
    closeDialog,
  });
</script>

<template>
  <ComponentDialog
    ref="refPatientAttributesDialog"
    dialog-width="large"
    dialog-type="abort"
    cancel-label="Schließen"
    :test-id="getTestId('patient-attributes')"
  >
    <template #content>
      <PatientsPatientAttributesData within-dialog :patient="patient" />
    </template>
  </ComponentDialog>
</template>
